import { h, Component } from 'preact';
import HTML from 'components/core/html/html.js';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';
import s from 'components/bolt/airport/popUpWindows/lostAndFound/lostAndFound.sss';

const TOUCH_SLOP = 8;

export default class LostAndFound extends Component {
	constructor(props) {
		super(props);
		const items = this.props?.section?.popUp?.items || [];
		this.bonusItem = items.find(item => item.secret);
		this.secretPattern = 'rrllrrlr';
		this.userPattern = '';
		this.onCarouselDragStart = this.onCarouselDragStart.bind(this);
		this.onCarouselDrag = this.onCarouselDrag.bind(this);
		this.onCarouselDragEnd = this.onCarouselDragEnd.bind(this);
		this.onClickItem = this.onClickItem.bind(this);
		this.state = {
			activeLostAndFoundIndex: 0,	
			items: items.filter(item => !item.secret)
		};
		this.lastLostAndFoundIndex = undefined;
	}

	componentDidUpdate(prevProps) {
		const { isOpen } = this.props;
		if (prevProps.isOpen && !isOpen && !this.bonusItemRevealed) {
			this.userPattern = '';
		}
	}

	onHoverItem(itemId, index) {
		const { activeLostAndFoundIndex } = this.state;
		if (index !== activeLostAndFoundIndex) {
			return;
		}
		Store.emit('ROB_UPDATE', `lostAndFound_${itemId}`);
	}

	onClickItem(e, index, nextIndex, prevIndex) {
		e.stopPropagation();

		if (index == nextIndex) {
			this.onCarouselNext(this.getCarouselItemLength());
		} else if (index == prevIndex) {
			this.onCarouselPrev(this.getCarouselItemLength());
		}
	}

	onCarouselDragStart(e) {
		if (this.carouselGrabbed || e.button !== undefined && e.button !== 0) {
			return;
		}
		if (!e.touches || !e.touches.length) {
			e.preventDefault();
		}
		let eventSource = e.touches && e.touches[0] || e;
		let pos = eventSource.pageX || 0;
		this.carouselGrabbed = {
			x: pos,
			y: eventSource.pageY || 0,
			previous: pos,
			lastEvent: Date.now()
		};
	}

	onCarouselDrag(e) {
		if (!this.carouselGrabbed) {
			return;
		}
		let eventSource = e.touches && e.touches[0] || e;
		let x = eventSource.pageX || 0;
		let y = eventSource.pageY || 0;
		let deltaX = Math.abs(x - this.carouselGrabbed.x);
		let deltaY = Math.abs(y - this.carouselGrabbed.y);
		if (!this.carouselGrabbed.active && deltaX < TOUCH_SLOP) {
			if (deltaY >= TOUCH_SLOP) {
				// Vertical swipe
				this.carouselGrabbed = false;
			}
			return;
		}
		if (!this.carouselGrabbed.active) {
			this.carouselGrabbed.x = x;
			this.carouselGrabbed.active = true;
		}
		if (e.cancelable) {
			e.preventDefault();
		}
		this.carouselGrabbed.lastEvent = Date.now();
		this.carouselGrabbed.speed = this.carouselGrabbed.previous - x;
		this.carouselGrabbed.previous = x;
	}

	onCarouselDragEnd(e) {
		let grabbed = this.carouselGrabbed;
		this.carouselGrabbed = false;
		if (grabbed) {
			if (!grabbed.active) {
				return;
			}
			let speed = grabbed.speed * Math.max(0, 1 - (Date.now() - grabbed.lastEvent) / 200);
			if (Math.abs(speed) > 0.2) {
				if (speed > 0) {
					this.onCarouselNext();
				} else if (speed < 0) {
					this.onCarouselPrev();
				}
			}
		}
	}

	onCarouselNext(itemLength) {
		if (!itemLength) {
			itemLength = this.getCarouselItemLength();
		}
		const { activeLostAndFoundIndex } = this.state;
		const newIndex = (activeLostAndFoundIndex + 1) % itemLength;
		const patternUnlocked = this.checkSecretPattern('r');
		this.setState({ activeLostAndFoundIndex: newIndex });
		if (patternUnlocked) {
			this.revealBonusItem(newIndex);
		}
	}

	onCarouselPrev(itemLength) {
		if (!itemLength) {
			itemLength = this.getCarouselItemLength();
		}
		const { activeLostAndFoundIndex } = this.state;
		const newIndex = (activeLostAndFoundIndex - 1 + itemLength) % itemLength;
		const patternUnlocked = this.checkSecretPattern('l');

		this.setState({ activeLostAndFoundIndex: newIndex });
		if (patternUnlocked) {
			this.revealBonusItem(newIndex);
		}
	}

	getCarouselItemLength() {
		return this.state.items?.length || 0;
	}

	getCarouselItemTransformValue(items, index) {
		const { activeLostAndFoundIndex } = this.state;

		if (index === activeLostAndFoundIndex) {
			return `translate(-50%, -50%)`;
		}

		const store = Store.get();
		const { client } = store;

		const isTablet = client.deviceSize === 'tablet';
		const isMobile = client.deviceSize === 'mobile';

		const initialOffset = isMobile ? 44 : isTablet ? 52 : 68 ;
		const offset = isMobile ? 120 : 140;
		const itemLength = items.length;

		const isPrev = ((activeLostAndFoundIndex - 1 + itemLength) % itemLength) === index;
		const isPrevInWaiting = ((activeLostAndFoundIndex - 2 + itemLength) % itemLength) === index;

		if (isPrev) {
			return `translate(calc(-50% - ${initialOffset + offset}px), -50%)`;
		} if (isPrevInWaiting) {
			return `translate(calc(-50% - ${initialOffset + offset * 2}px), -50%)`;
		}
		// put everything else on the right
		const offsetFactor = index - activeLostAndFoundIndex < 0 ? itemLength + (index - activeLostAndFoundIndex) : index - activeLostAndFoundIndex;
		return `translate(calc(-50% + ${initialOffset + (offsetFactor * offset)}px), -50%)`;
	}

	checkSecretPattern(dir) {
		if (this.bonusItemRevealed) return;
		this.userPattern = this.userPattern + dir;
		return !!this.userPattern.match(this.secretPattern);
	}

	revealBonusItem(targetIndex) {
		if (!this.bonusItem) {
			return;
		}
		if (this.bonusItemRevealed) {
			return;
		}
		this.bonusItemRevealed = true;
		const { items } = this.state;
		const newItems = [...items];
		newItems.splice(targetIndex, 0, this.bonusItem);
		Store.emit('PLAY_SOUND', 'lostAndFoundSecret');
		this.setState({ items: newItems });
	}

	render({ section, imageRoot, isOpen }) {
		const { activeLostAndFoundIndex, lastLostAndFoundIndex, items } = this.state;
		const copy = section?.popUp?.copy || {};

		if (isOpen) {		
			if (activeLostAndFoundIndex != lastLostAndFoundIndex) {
				Store.emit('CUSTOM_EVENT', {
					category: 'lost-and-found',
					action: 'lost-and-found-carousel-view',
					label: items[activeLostAndFoundIndex].id
				});

				this.setState({ lastLostAndFoundIndex: activeLostAndFoundIndex });
				this.lastLostAndFoundIndex = activeLostAndFoundIndex ;
			}
		} else {
			this.lastLostAndFoundIndex = undefined; 
		}

		return (
			<div
				class={s.container}
				onMouseDown={(e) => e.stopPropagation()}
				onTouchStart={(e) => e.stopPropagation()}
			>
				<div class={s.subtitle}>
					<HTML
						class={s.text}
						markdown
						content={section.popUp?.copy.subtitle}
					/>
				</div>
				<div class={s.carouselContainer}>
					<div
						class={s.carousel}
						onMouseDown={this.onCarouselDragStart}
						onTouchStart={this.onCarouselDragStart}
						onMouseMove={this.onCarouselDrag}
						onTouchMove={this.onCarouselDrag}
						onMouseUp={this.onCarouselDragEnd}
						onTouchEnd={this.onCarouselDragEnd}
					>
						{items.map((item, index) => {
							const itemTransformValue = this.getCarouselItemTransformValue(items, index);
							const nextIndex = (activeLostAndFoundIndex + 1) % items.length;
							const prevIndex = (activeLostAndFoundIndex - 1 + items.length) % items.length;
							const invisible = index !== activeLostAndFoundIndex && index !== nextIndex && index !== prevIndex;
							return (
								<button
									class={joinClasses(
										s.carouselItem,
										index !== activeLostAndFoundIndex && s.inactive,
										invisible && s.hide,
										item.secret && s.secretItem
									)}
									key={`${item.id}-lost-and-found-item`}
									style={{ transform: itemTransformValue }}
									onMouseEnter={() => this.onHoverItem(item.id, index)}
									onClick={(e) => this.onClickItem(e, index, nextIndex, prevIndex)}
								>
									<div class={s.imgContainer}>
										<img src={`${imageRoot}/airport/${item.asset}`} />
									</div>
									<div class={s.carouselItemText}>
										<p class={s.carouselItemName}>{copy.items[item.id].name}</p>
										<p class={s.carouselItemDescription}>{copy.items[item.id].description}</p>
									</div>
								</button>
							);
						})}
					</div>
					<div class={s.carouselArrows}>
						<button class={joinClasses(s.carouselArrow, s.prevArrow)} onClick={() => this.onCarouselPrev(items.length)}>
							<img src={`${imageRoot}/airport/back.webp`} />
						</button>
						<button class={joinClasses(s.carouselArrow, s.nextArrow)} onClick={() => this.onCarouselNext(items.length)}>
							<img src={`${imageRoot}/airport/next.webp`} />
						</button>
					</div>
				</div>
			</div>
		);
	}
}